<ng-container *transloco="let t">
@if (isMobile) {
  <div class="pb-55">
    <ng-template [ngTemplateOutlet]="userInfo"></ng-template>
    <ng-template [ngTemplateOutlet]="eventsButtons"></ng-template>
    <ng-template [ngTemplateOutlet]="userPreviewElements"></ng-template>
    <ng-template [ngTemplateOutlet]="upcoming"></ng-template>
    @if ((recommendedEvents?.length ?? 0) > 0) {
      <ng-template [ngTemplateOutlet]="recommended"></ng-template>
    }
  </div>
}
@else {
    <div class="py-3 row">
        <div class="col-12 col-md-custom-30">
            <ng-template [ngTemplateOutlet]="userInfo"></ng-template>
            <ng-template [ngTemplateOutlet]="userPreviewElements"></ng-template>
        </div>
        <div class="col-12 col-md-custom-70 d-none d-md-block">
          <ng-template [ngTemplateOutlet]="upcoming"></ng-template>
          @if ((recommendedEvents?.length ?? 0) > 0) {
            <ng-template [ngTemplateOutlet]="recommended"></ng-template>
          }
        </div>
     </div>
    }

    <ng-template #userInfo>
        <div class="profile-section d-flex align-items-center mb-24-16">
            <div class="avatar-wrapper">
                <div class="avatar">
                    @if (currentUserDetails?.picture) {
                        <img [src]="currentUserDetails!.picture!" class="avatar-img">
                    }
                    @else {
                        <img [src]="'assets/icons/icons-alt/avatar.svg'" [width]="26" [height]="26">
                    }
                </div>
                <button type="button" (click)="goToEditProfile()" class="edit-btn d-flex align-items-center justify-content-center">
                    <img src="assets/icons/icons-alt/edit-2.svg" alt="Edit">
                </button>
            </div>

            <div class="profile-info">
                <p class="fs-16 fw-600 color-slate-800">
                    {{ currentUserDetails?.firstname | titlecase }} {{ currentUserDetails?.lastname | titlecase}}
                </p>
                @if (currentUserDetails?.city || currentUserDetails?.country) {
                <div class="d-flex justify-content-start align-items-center color-slate-500">
                  @if (currentUserDetails?.country) {
                    <div [class]="'fi fi-' + ((currentUserDetails!.country! | country:'isoCode') | lowercase)" class="flag"></div>
                    }
                    <p class="fw-400 fs-12 ps-1">{{ [(currentUserDetails?.city | titlecase), (currentUserDetails?.country | country:'iocCode')] | joinNonEmpty }}</p>
                </div>
                }
                @if (currentUserDetails?.club) {
                <div class="d-flex align-items center gap-1 fs-12">
                  <p class="fw-400 color-slate-500"> {{ t('app.common.club') }} </p>
                  <p class="fw-600 color-slate-800"> {{ currentUserDetails?.club }} </p>
                 </div>
                }
            </div>
        </div>
    </ng-template>


    <ng-template #eventsButtons>
      <div class="events-buttons-scroll">
        <div class="row row-cols-3 gx-2 mb-3" style="width: max-content; min-width: 100%;">
          <div class="col">
              <div class="profile-section clickable py-2 my-2" (click)="navigateToPage(MyTraceyTabs.UPCOMING)">
                  <div class="fw-500 d-flex mb-2">
                      <div class="events-badge d-flex justify-content-center align-items-center me-2">
                          <img src="assets/icons/icons-alt/calendar-04.svg" alt="Calendar" width="20" height="20"/>
                      </div>
                      <span>
                           {{ upcomingEvents.length > 0
                          ? (upcomingEvents.length > DEFAULT_PAGE_SIZE
                              ? DEFAULT_PAGE_SIZE + "+"
                              : upcomingEvents.length)
                          : '-' }}
                      </span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center gap-2">
                    <div>
                        <p>{{  t('app.common.registrations') }}</p>
                    </div>
                    <div class="events-btn">
                      <img src="assets/icons/icons-alt/chevron-circle.svg" alt="Open" width="18" height="18"/>
                    </div>

                  </div>
              </div>
          </div>

          <div class="col">
            <div class="profile-section clickable py-2 my-2" (click)="navigateToPage(MyTraceyTabs.FAVORITES)">
              <div class="fw-500 d-flex mb-2">
                <div class="events-badge d-flex justify-content-center align-items-center me-2">
                  <img src="assets/icons/icons-alt/save-alt.svg" alt="Saved" width="20" height="20"/>
                </div>
                <span>
                            {{ favoriteEvents.length > 0
                  ? (favoriteEvents.length > DEFAULT_PAGE_SIZE
                    ? DEFAULT_PAGE_SIZE + "+"
                    : favoriteEvents.length)
                  : '-' }}
                        </span>
              </div>
              <div class="d-flex justify-content-between align-items-center gap-2">
                <div>
                  <p>{{  t('app.common.saved') }}</p>
                </div>
                <div class="events-btn">
                  <img src="assets/icons/icons-alt/chevron-circle.svg" alt="Open" width="18" height="18"/>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
              <div class="profile-section clickable py-2 my-2" (click)="navigateToPage(MyTraceyTabs.RESULTS)">
                  <div class="fw-500 d-flex mb-2">
                      <div class="events-badge d-flex justify-content-center align-items-center me-2">
                        <img src="assets/icons/icons-alt/result-line.svg" alt="Results" width="18" height="18"/>
                      </div>
                      <span>
                          {{ pastEvents.length > 0
                              ? (pastEvents.length > DEFAULT_PAGE_SIZE
                                  ? DEFAULT_PAGE_SIZE + "+"
                                  : pastEvents.length)
                              : '-' }}
                      </span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center gap-2">
                    <div>
                        <p>{{  t('app.user.profile.my.results') }}</p>
                    </div>
                    <div class="events-btn">
                      <img src="assets/icons/icons-alt/chevron-circle.svg" alt="Open" width="18" height="18"/>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </ng-template>


    <ng-template #userPreviewElements>
        <div class="pb-3 profile-section mb-4">
        <div class="mb-2 d-flex justify-content-between align-items-center">
            <div class="d-flex fw-bold fs-14 text-uppercase color-slate-500">
                <p> {{ t('app.user.profile.stats') }} {{ currentYear }} </p>
            </div>
        </div>

        <div>
            <div class="stats-grid">
              <div class="stat">
                <p class="fw-400">{{  t('app.user.profile.my.events') }}</p>
                <p class="color-slate-800 fs-18">{{ hasRealStats ? userStatistics!.racesCount : '-' }}</p>
              </div>
              <div class="divider-vertical"></div>
              <div class="stat">
                <p class="fw-400">{{ t('competitor.table.distance') }}</p>
                <p class="color-slate-800 fs-18">{{ hasRealStats && userStatistics!.distance
                  ? (userStatistics!.distance | raceLengthFormat:translocoService.getActiveLang():'m')
                  : '-' }}</p>
              </div>
              <div class="divider-vertical"></div>
              <div class="stat">
                <p class="fw-400">{{  t('competitor.table.time') }}</p>
                <p class="color-slate-800 fs-18">{{ hasRealStats && userStatistics!.totalTime
                  ? (userStatistics!.totalTime | cumulativeTime)
                  : '-' }}</p>
              </div>
            </div>

          @if (!hasRealStats && userStatistics) {
            <div class="divider-horizontal margin-16"></div>

            @if (upcomingEvents.length > 0) {
              <!-- korisnik ima registracije - neovisno o stats godini-->
              <app-empty-state [backgroundColor]="'transparent'" [hasPadding]="false"
                               [hasBoxShadow]="false"
                               [contentKeys]="['empty.state.profile.no.results.title']"
                               [contentKeysSecondary]="['empty.state.profile.overview.stats.no.finished.results.description']"/>

            } @else if (statsYear === lastYear) {
              <!-- korisnik nema registracije, stats za prošlu godinu -->
              <app-empty-state [backgroundColor]="'transparent'" [hasPadding]="false"
                               [hasBoxShadow]="false"
                               [contentKeys]="['empty.state.profile.overview.stats.no.events.title']"
                               [contentKeysSecondary]="['empty.state.profile.overview.stats.no.events.description']"
                               [contentKeysSecondaryParams]="{
                                eventCount: userStatistics?.racesCount ?? 0,
                                distance: (userStatistics?.distance ?? 0) / 1000
                               }"/>
            } @else if (statsYear! < lastYear!) {
              <!-- korisnik nema registracije, stats stariji od prošle godine -->
              <app-empty-state [backgroundColor]="'transparent'" [hasPadding]="false"
                               [hasBoxShadow]="false"
                               [contentKeys]="['empty.state.profile.overview.stats.no.events.title']"
                               [contentKeysSecondary]="['empty.state.profile.overview.stats.returning.user.description']"/>
            } @else {
              <!-- korisnik nema registracije, nema stats, novi user -->
              <app-empty-state [backgroundColor]="'transparent'" [hasPadding]="false"
                               [hasBoxShadow]="false"
                               [contentKeys]="['empty.state.profile.overview.stats.new.user.title']"
                               [contentKeysSecondary]="['empty.state.profile.overview.stats.new.user.description']"/>
            }
          }

        </div>
<!--            todo stats details-->
<!--        @if (!isMobile) {-->
<!--        <div class="pt-3">-->
<!--          <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(&#45;&#45;teal-500)'" [buttonHeight]="'30px'"-->
<!--                          [fontWeight]="'500'" [text]=" t('app.common.view.details') | uppercase"-->
<!--                          [borderColor]="'transparent'" [fontSize]="'14px'"-->
<!--                          [additionalClass]="'p-0'" ></app-button-alt>-->
<!--        </div>-->
<!--        }-->
    </div>

    @if (latestEvent) {
         <div class="mb-24-16 profile-section-desktop">
            <div class="py-2 mb-2 d-flex justify-content-between align-items-center">
                <div class="d-flex fw-500 fs-20">
                    <div style="width: 5px; height: auto; background-color: #b05963; border-radius: 8px;" class="me-3"></div>
                    <p> {{ t('app.user.profile.latest.event') }} </p>
            </div>
        </div>

        <div class="profile-section-mobile">
            <div class="d-flex flex-column line-height-1">
                <p class="fs-18 trim-text-second-line my-2 text-uppercase pb-1">
                    <app-language-output [hrLabel]="latestEvent!.name" [srLabel]="latestEvent!.nameSr"
                                         [enLabel]="latestEvent!.nameEng" [itLabel]="latestEvent!.nameIta"
                                         [bsLabel]="latestEvent!.nameBs" [siLabel]="latestEvent!.nameSlo"
                                         [defaultLanguage]="latestEvent!.defaultLanguage" [languages]="languages"/>
                </p>

                <div class="latest-event-grid">
                    <div class="d-flex align-items-center me-3">
                        <div class="d-flex justify-content-center align-items-center me-2">
                            <img src="assets/icons/icons-alt/calendar-04.svg" alt="Upcoming events" width="18" height="18"/>
                        </div>
                        <app-event-date-display [start]="latestEvent.start" [end]="latestEvent.end" class="fs-14 fw-400"/>
                    </div>

                    <div class="d-flex align-items-center">
                        @if (latestEvent?.sportOne || latestEvent?.sportTwo) {
                        <div class="tag">
                          @if (latestEvent?.sportOne) {
                        <p> {{t("app.common.sports." + latestEvent?.sportOne)}} </p>
                        } @else if (latestEvent?.sportTwo) {
                        <p> {{t("app.common.sports." + latestEvent?.sportTwo)}} </p>
                        }
                        </div>
                        }
                    </div>
                </div>

                <div class="stats-grid-event mt-2">
                    <div class="stat-event">
                        <p class="fw-300 mb-1">{{  t('competitor.table.time') }}</p>
                        <p class="fs-16">30:03:22</p>
                    </div>
                    <div class="stat-event">
                        <p class="fw-300 mb-1">{{  t('competitor.table.distance') }}</p>
                        <p class="fs-16">125km</p>
                    </div>
                    <div class="stat-event">
                        <p class="fw-300 mb-1">{{  t('competitor.table.tempo') }}</p>
                        <p class="fs-16">6.58 km/h</p>
                    </div>
                    <div class="stat-event">
                        <p class="fw-300 mb-1">{{  t('competitor.table.absolute.rank') }}</p>
                        <p class="fs-16">#1</p>
                    </div>
                </div>
            </div>

            <div class="pt-3 my-1 d-flex justify-content-end justify-content-md-normal">
                <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'20px'"
                                [fontWeight]="'500'" [text]="t('app.common.view.details') | uppercase"
                                [borderColor]="'transparent'" [fontSize]="'14px'"
                                [additionalClass]="'p-0'" (onClickCallback)="goToLatestEvent()"></app-button-alt>
            </div>
        </div>
    </div>
    }
<!--        todo clubs-->
<!--    <div class="profile-section p-0 pb-2 my-2 mb-4">-->
<!--        <div class="position-relative">-->
<!--            <img src="assets/img/bg3.jpg" alt="Upcoming events" class="join-club-img rounded-top-3" />-->
<!--            <div class="position-absolute bottom-0 start-0 p-4 pb-4 text-white fs-20">-->
<!--                <p>{{  t('app.user.join.club.line1') }} <br>-->
<!--                    {{  t('app.user.join.club.line2') }}-->
<!--                </p>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="px-3 py-2 fw-300">-->
<!--            <p>{{  t('app.user.join.club.description') }}</p>-->
<!--            <div class="d-flex justify-content-end mb-2 mt-4">-->
<!--                <app-button-alt [buttonColor]="'var(&#45;&#45;teal-500)'" [textColor]="'white'" [buttonHeight]="'30px'"-->
<!--                                [text]=" t('app.common.explore') | uppercase" [borderColor]="'var(&#45;&#45;teal-500)'" [fontSize]="'14px'"-->
<!--                ></app-button-alt>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
    </ng-template>


    <ng-template #recommended>
        <div class="d-flex justify-content-between align-items-center py-3">
            <div class="d-flex fw-500 fs-20">
                <p> {{  t('app.user.profile.recommended') }} </p>
            </div>
            <div class="d-flex justify-content-end align-items-center">
                <button class="scroll-btn me-3" (click)="scrollEvents(false)">
                  <img src="assets/icons/icons-alt/chevron-left-alt.svg" alt="Left" class="cursor-pinter"/>
                </button>
                <button class="scroll-btn" (click)="scrollEvents(true)">
                  <img src="assets/icons/icons-alt/chevron-right-alt.svg" alt="Left" class="cursor-pinter"/>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-3">
            @if (recommendedEvents.length ?? 0 > 0) {
            <div class="events-scroll-container pb-3">
              @for (item of recommendedEvents; track item) {
                <div class="event-item">
                    <app-event-grid-item [eventItem]="item"
                                         [layout]="CalendarViewType.GRID"
                                         [isClickable]="true"
                                         (onRightButtonClickCallback)="goToEventDetailsPage(item)"
                                         [languages]="languages" [showActionButton]="false"
                    />
                </div>
            }
            </div>
            } @else {
            <app-empty-state [contentKeys]="['app.common.my.upcoming.no.events']"/>
            }
        </div>
    </ng-template>

  <ng-template #upcoming>
    <div class="py-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex fw-500 fs-20">
          <p> {{ t('app.landing.upcoming.events') }} </p>
        </div>

        <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'30px'"
                        [text]=" t('app.common.view.all') | uppercase" [borderColor]="'transparent'" [fontSize]="'14px'"
                        [additionalClass]="'p-0'" (onClickCallback)="navigateToPage(MyTraceyTabs.UPCOMING)"></app-button-alt>

      </div>
        @if (upcomingEvents.length ?? 0 > 0) {
          <div class="row row-cols-1">
            @for (item of upcomingEvents.slice(0, UPCOMING_EVENTS_COUNT); track item.competitor?.id ?? $index) {
              <div class="col py-10">
                <app-user-event-grid-item
                  [userEvent]="item"
                  [type]="UserEventGridItemType.UPCOMING"
                  [rightButtonKey]="'app.common.my.registration'"
                  [layout]="isMobile ? CalendarViewType.GRID : CalendarViewType.LIST"
                  (onRightButtonClickCallback)="goToMyEntry(item)"
                  [languages]="languages"/>
              </div>
            }
          </div>
        } @else if (pastEvents.length > 0) {
          <app-empty-state [contentKeys]="['empty.state.profile.no.upcoming.events.title']"
                           [contentKeysSecondary]="['empty.state.profile.no.upcoming.events.returning.description']"
                           [backgroundColor]="'white'"
                           [imgSrc]="'calendar-light.svg'"
                           [buttonText]="'app.common.browse.events'" [hasPadding]="false"
                           (onButtonClick)="goToEventCalendar()"/>
        } @else {
          <app-empty-state [contentKeys]="['empty.state.profile.no.upcoming.events.title']"
                           [contentKeysSecondary]="['empty.state.profile.no.upcoming.events.description']"
                           [backgroundColor]="'white'"
                           [imgSrc]="'calendar-light.svg'"
                           [buttonText]="'app.common.browse.events'" [hasPadding]="false"
                           (onButtonClick)="goToEventCalendar()"/>
        }

    </div>
  </ng-template>

</ng-container>
